import { render, staticRenderFns } from "./SchoolLocation.vue?vue&type=template&id=62486e33&"
import script from "./SchoolLocation.vue?vue&type=script&lang=js&"
export * from "./SchoolLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports